import {Http} from '../../../Data/config/Http';
import {
  VisitDTO,
  VisitStatisticsDTO,
  VisitTrendsDTO
} from '../models/visit.dto';
import {API_ROUTES} from '../../../constants/apiRoutes';
import type {BaseResponse, Pagination} from '../../../Data/types/BaseResponse';
import {VisitFilters} from '../models/visit.model';
import {ApiUtils} from '../../../constants/apiRoutes';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';

// Note: Request interfaces are defined in VisitAPIDataSourceManagement.ts

export const VisitAPIDataSourceCore = {
  // Visits Overview
  getOverview: async (): Promise<VisitStatisticsDTO> => {
    try {
      const response = await Http.get<BaseResponse<VisitStatisticsDTO>>(
        API_ROUTES.VISITS.OVERVIEW
      );
      return unwrapResponse(response.data, 'حدث خطأ في جلب إحصائيات الزيارات');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // Visits List with Filters
  getVisits: async (filters: VisitFilters = {}): Promise<{data: VisitDTO[], pagination: Pagination}> => {
    try {
      // The backend reads the visitor/developer filter as `user_id` (it maps to
      // visit.visitor_id server-side). Translate our domain key at the API
      // boundary so `?visitor_id=` isn't silently ignored.
      const {visitor_id, ...rest} = filters;
      const queryParams: Record<string, unknown> = {
        ...rest,
        ...(visitor_id !== undefined ? {user_id: visitor_id} : {})
      };
      const url = ApiUtils.buildUrl(API_ROUTES.VISITS.LIST, queryParams);
      const response = await Http.get<BaseResponse<VisitDTO[]>>(url);
      const raw = response.data;
      const items = unwrapResponse(raw, 'حدث خطأ في جلب قائمة الزيارات');
      return {
        data: Array.isArray(items) ? items : [],
        pagination: raw.pagination || {page: 1, limit: 20, total: 0, totalPages: 1}
      };
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // Visit Details
  getVisitDetails: async (visitId: string | number): Promise<VisitDTO> => {
    try {
      const response = await Http.get<BaseResponse<VisitDTO>>(
        API_ROUTES.VISITS.DETAILS(visitId.toString())
      );
      return unwrapResponse(response.data, 'حدث خطأ في جلب تفاصيل الزيارة');
    } catch (error) {
      handleDataSourceError(error);
    }
  },

  // Visit Trends — نفس endpoint للتحليلات
  getTrends: async (): Promise<VisitTrendsDTO> => {
    try {
      const response = await Http.get<BaseResponse<VisitTrendsDTO>>(
        API_ROUTES.VISITS.ANALYTICS
      );
      return unwrapResponse(response.data, 'حدث خطأ في جلب تحليلات الزيارات');
    } catch (error) {
      handleDataSourceError(error);
    }
  }

  // generateReport removed - export functionality not needed in dashboard
};
